import React from 'react';
import VideoPlayer from '../component/MyCourseViewComponents/VideoPlayer';

const VideoPlayerTest = () => {
    const videoQualities = {
        "1080p": "processed-videos/c1ebe7c1-90d3-4a3b-922a-5d10703d9072/392feece-6f6f-4a31-952f-0985dc8997d0_1080p.mp4",
        "720p": "processed-videos/c1ebe7c1-90d3-4a3b-922a-5d10703d9072/392feece-6f6f-4a31-952f-0985dc8997d0_720p.mp4",
        "480p": "processed-videos/c1ebe7c1-90d3-4a3b-922a-5d10703d9072/392feece-6f6f-4a31-952f-0985dc8997d0_480p.mp4",
        "360p": "processed-videos/c1ebe7c1-90d3-4a3b-922a-5d10703d9072/392feece-6f6f-4a31-952f-0985dc8997d0_360p.mp4",
    }

    return (
        <div style={{ padding: '20px' }}>
            <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Course Video Player</h1>
            <VideoPlayer videoQualities={videoQualities} />
        </div>
    );
};

export default VideoPlayerTest;